/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { QuestionEventInterface, QuizQuestion, Direction } from './QuizQuestion';
import { QuizAnswerTile } from './QuizAnswerTile';
import { QuizAnswerRange } from './QuizAnswerRange';

export interface QuizDataInterface {
    main_product: string;
    alt_products: string[];
    default_product_page: boolean;
    grind: string;
    grind_variant: string;
    frequency: number;
    quantity: 1;
}

@Component
export class QuizContainer extends ThemeComponent {
    @Ref questions!: QuizQuestion[];

    private questionData!:QuestionEventInterface;
    private history:QuizQuestion[] = [];
    private step:number = 0;

    init() {
        this.questions[this.step].classList.remove('visually-hidden');

        for (const question of this.questions) {
            this.$subscribe(question.onChange, (ev:QuestionEventInterface) => {
                this.questionData = ev;

                this.handleQuestions();
            });
        }
    }

    processData() {
        const selectedQuestions = [...this.history];
        const data:QuizDataInterface = {
            main_product: "",
            alt_products: [],
            default_product_page: false,
            grind: '',
            grind_variant: '',
            frequency: 1,
            quantity: 1
        };

        for (const selectedQuestion of selectedQuestions) {
            const question = selectedQuestion as QuizQuestion;
            const tile = question.querySelector('quiz-answer-tile.active') as QuizAnswerTile;
            const rangeSlider = question.querySelector('quiz-answer-range') as QuizAnswerRange;

            if (tile) {
                const {
                    main_product,
                    alt_products,
                    default_product_page,
                    grind,
                    grind_variant,
                    frequency,
                    quantity
                } = tile.getData();

                const obj = {};

                if (main_product !== "") {
                    data.main_product = main_product;
                }

                if (alt_products !== "") {
                    const current = data.alt_products;
                    const format = alt_products.split(',').map((el:string) => el);
                    const products_array = [...current, ...format];
                    data.alt_products = products_array.filter(function(item: string, pos: number) {
                        return products_array.indexOf(item) == pos;
                    });
                }

                if (default_product_page === 'true') {
                    data.default_product_page = true;
                } else {
                    data.default_product_page = false;
                }

                if (grind_variant !== "") {
                    data.grind_variant = grind_variant;
                }

                if (grind !== '') {
                    data.grind = grind;
                }
            } else {
                const {
                    quantity,
                    frequency
                } = rangeSlider.getData();

                data.quantity = quantity;
                data.frequency = frequency;
            }
        }

        if (data.default_product_page) {
            const url = `${window.location.origin}/products/${data.main_product}`;

            window.location.href = url;
        } else {
            const lc = localStorage.getItem('quizData');

            if (lc) {
                localStorage.removeItem('quizData');
            }

            localStorage.setItem('quizData', JSON.stringify(data));
            const url = `${window.location.origin}/products/${data.main_product}?view=quiz-result`;

            window.location.href = url;
        }
    }

    handleQuestions() {
        const {
            direction,
            el,
            nextRoute
        } = this.questionData;

        const next = () => {
            const [el] = this.questions.filter((question) =>
                question.dataset.route === this.questionData.nextRoute
            );

            el.classList.remove('visually-hidden');
        };

        const back = () => {
            const previousQuestion = this.history[this.history.length - 1];
            this.history.pop();
            previousQuestion.classList.remove('visually-hidden');
        };


        if (!nextRoute && direction !== Direction.back) {
            this.history.push(el);
            this.processData();
            return;
        }

        if (direction === Direction.forward) {
            this.history.push(el);
            next();
        }

        if (direction === Direction.back) {
            back();
        }
    }
}
